import type { Key } from 'react';
import AutoSuggestComponent, {
  type AutosuggestPropsSingleSection,
  type RenderInputComponentProps,
} from 'react-autosuggest';
import { Input } from '~/components/ui/Input';
import type { InputProps } from '~/components/ui/Input';
import { classNames } from '~/utils/classNames';

import styles from './AutoSuggestInput.module.scss';

interface Props<T> extends AutosuggestPropsSingleSection<T> {
  error?: InputProps['error'];
  isLoading?: boolean;
}

export function AutoSuggestInput<T>({ inputProps: baseInputProps, error, isLoading, ...restProps }: Props<T>) {
  return (
    <AutoSuggestComponent
      highlightFirstSuggestion
      theme={styles}
      inputProps={{
        autoComplete: 'off',
        autoCorrect: 'off',
        autoCapitalize: 'off',
        spellCheck: false,
        ...baseInputProps,
      }}
      renderInputComponent={(inputProps: RenderInputComponentProps & { key?: Key }) => {
        // remove 'key' from props if present to avoid React warning about spreading 'key' into JSX
        const { size, className, key: _ignored, ...rest } = inputProps;
        const baseInputClassName = 'pl-8';

        return (
          <div className="relative">
            <Input error={error} inputClassName={classNames(baseInputClassName, className)} {...rest} />
            {isLoading && <div className="i-svg-spinners:90-ring-with-bg text-lg absolute left-2 top-3.5 w-4 h-4" />}
          </div>
        );
      }}
      {...restProps}
    />
  );
}
